import { List, Typography } from "@material-ui/core";
import {
  makeStyles,
  createStyles,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import MuiListItem from "@material-ui/core/ListItem";

import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listContainer: {
      background: "#FFF",
      padding: theme.spacing(0, 1),
    },
    optionsContainer: {
      width: "100%",
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(3),
    },
    title: {
      padding: theme.spacing(0, 1),
    },
  })
);

const SecondaryListItem = withStyles(({ palette, spacing }) => ({
  root: {
    paddingBottom: spacing(1),
    paddingTop: spacing(1),
    marginBottom: spacing(1),
    width: "100%",
    borderRadius: "0px",
    "&$selected": {
      backgroundColor: `${palette.primary.main}4D !important `,
    },
    "&$selected:hover": {
      backgroundColor: palette.primary.main,
    },
    "&:hover": {
      backgroundColor: `${palette.primary.main}4D !important `,
    },
  },
  selected: {},
  divider: {},
}))(MuiListItem);

export const NotificationGroupsConfigMenu = (props: IProps) => {
  const { selected, onClick } = props;

  /* Hooks */
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <h3 className={classes.title}>
        {t("notification_group_configuration").toUpperCase()}
      </h3>
      <List className={classes.optionsContainer}>
        <SecondaryListItem
          button
          divider
          disableGutters
          onClick={onClick}
          selected={selected}
          className={classes.listContainer}
        >
          <Typography variant="subtitle2">
            {t("unit_escalation_groups")}
          </Typography>
        </SecondaryListItem>
      </List>
    </>
  );
};

interface IProps {
  selected: boolean;
  onClick: () => void;
}
